/**
 * For CPS Withdraw Listing Ordering
 * (CPS Module)
 */

import { countryCodeEnum } from '@/constants/country'

export const withdrawListingIndex = [
  // Country Specific Sample
  // {
  //   id: countryCodeEnum.INDIA,
  //   order: [31, 7, 4],
  // },
  {
    id: 'global',
    order: [110],
  },
  {
    id: countryCodeEnum.PHILIPPINES,
    order: [40, 34, 36, 80, 81],
  },
  {
    id: countryCodeEnum.INDONESIA,
    order: [39, 7, 34, 36, 80, 81],
  },
  {
    id: countryCodeEnum.MEXICO,
    order: [63, 34, 36, 80, 81],
  },
  {
    id: countryCodeEnum.BRAZIL,
    order: [100, 64, 34, 36, 80, 81],
  },
  {
    id: countryCodeEnum.THAILAND,
    order: [36, 34, 80, 81, 5],
  },
  {
    id: countryCodeEnum.INDIA,
    order: [36, 34, 80, 81, 24],
  },
]
